import { useRouter } from 'next/router'
import { useSelector } from 'react-redux'

const usePlaceName = queryParams => {
  const router = useRouter()
  const place = useSelector(state => state.placeFilter)

  const getPlaceName = () => {
    let placesQueries: any[] = []

    if (
      !decodeURIComponent(router.pathname + ' ' + router.asPath)?.includes(
        'تهران',
      ) ||
      queryParams.near_cities
    ) {
      return ''
    }

    for (const key in place?.data) {
      if (Object.prototype.hasOwnProperty.call(place?.data, key)) {
        const item = place?.data[key]
        if (item.places) {
          placesQueries = [...placesQueries, ...item.places]
        } else {
          placesQueries = [
            ...placesQueries,
            { label: item.label, query_parameters: item.query_parameters },
          ]
        }
      }
    }

    const activePlaceItem = placesQueries.filter(
      q =>
        q?.query_parameters?.includes(`place_id=${queryParams.place_id}`) ||
        q?.query_parameters?.includes(`tag=${queryParams.tag}`),
    )?.[0]?.label

    return activePlaceItem
  }

  return getPlaceName()?.replace(' تهران', '')
}

export default usePlaceName
